<template>
    <div class="orderItem" >
        <!-- <OrderNo :orderNo="rows.order_no"/> -->
        <OrderAddress  :distance="rows.distance" :shopName="supplierName" :address="supplierAddress" :lat="supplierLat" :lng="supplierLng"/>
        <div class="orderMeta">
            <span>Order No: {{ rows.order_no || '--' }}</span>
            <span class="status">{{ getMixinOrderStatus(rows.order_status) || '--' }}</span>
        </div>
        <div class="dateGroup" v-if="rows.service && rows.service.length > 0" @click="handleGoDetail(rows.order_id)">
            <div v-for="item in rows.service" class="dateItem">
                <div>{{item.service_name}}</div>
                <div style="margin: 0.25rem 0;font-size:1.2rem">{{ formatTimestamp(item.start_time,'YYYY-MM-DD', supplierTimezone) }}</div>
                <div class="dateTime">
                    <div>{{ formatTimestamp(item.start_time,'HH:mm', supplierTimezone) }}</div>
                    <div class="line"></div>
                    <div>{{ formatTimestamp(item.end_time,'HH:mm', supplierTimezone) }}</div>
                    <div style="margin-left:5px">({{ getMinute(item.minute,item.hour) }} min)</div>
                </div>
            </div>
        </div>
        <OrderPhone v-if="rows.supplier" :phone="rows.supplier.link_phone"/>
        <van-divider dashed :style="{ borderColor: '#1A3232' }"></van-divider>
        <div class="priceBox">
            <div style="font-weight:bold">$ {{ rows.order_total || rows.total_price }}</div>
            <!-- order_status = 10 OrdersIn Progress -->
            <div class="btnGroup" v-if="rows.order_status == 10 ">
                <div class="Btn2" @click.stop="handleCancel">Cancel Order</div>
                <!-- pay_status = 0 未付款, pay_type = 2 或 4 -->
                <div class="Btn1" v-if="rows.pay_status == 0 && (rows.pay_type == 2 || rows.pay_type == 4)" @click.stop="handlePay" >Pending Payment</div>
            </div>
            <!-- order_status = 30 Completed -->
            <div class="btnGroup" v-if="rows.order_status == 30 ">
                <!-- ReviewedOrders不显示“追加评价”按钮 -->
                <div class="Btn1" v-if="isUnreviewed(rows)" @click.stop="handleCollection">Review Now</div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Dialog,Toast  } from 'vant';
    import myMixin  from '@/utils/myMixin'
    import OrderAddress from '@/components/Order/address.vue'
    import OrderPhone from '@/components/Order/phone.vue'
    import OrderNo from '@/components/Order/no.vue'
    export default {
        name:'OrderItem',
        props:{
            rows:{
                type:Object,
                default:()=>{
                    return {}
                }
            }
        },
        mixins:[myMixin],
        data(){
            return {
            }
        },
        computed:{
            supplierName(){
                if (this.rows.supplierDetail && this.rows.supplierDetail.name) {
                    return this.rows.supplierDetail.name
                }
                return this.rows.supplier ? this.rows.supplier.name : ''
            },
            supplierAddress(){
                if (this.rows.supplierDetail && this.rows.supplierDetail.address) {
                    return this.rows.supplierDetail.address
                }
                return ''
            },
            supplierLat(){
                const detail = this.rows.supplierDetail || {}
                const raw = detail.latitude || detail.lat || detail.shop_lat
                const n = Number(raw)
                return Number.isFinite(n) ? n : ''
            },
            supplierLng(){
                const detail = this.rows.supplierDetail || {}
                const raw = detail.longitude || detail.lng || detail.shop_lng
                const n = Number(raw)
                return Number.isFinite(n) ? n : ''
            },
            supplierTimezone(){
                return (this.rows.supplierDetail && this.rows.supplierDetail.timezone) || ''
            }
        },
        components:{
            OrderAddress,
            OrderPhone,
            OrderNo
        },
        methods:{
            isUnreviewed(order){
                return !!order && Number(order.is_comment) === 0
            },
            handleGoDetail(id){
                this.$router.push({path:'/orderDetail',query:{id:id}})
            },
            getMinute(minute,hour){
                let min = minute
                if( hour > 0 ){
                    min += hour * 60
                }
                return min
            },
            // 取消 Order
            handleCancel(){
                let _this = this
                Dialog.confirm({
                    title: 'Delete',
                    message: 'Cancel this booking? Paid orders are not refunded online; please contact the store to discuss a refund in person.',
                })
                .then(() => {
                    this.$api.cancelOrder({order_id:this.rows.order_id}).then(res=>{
                        if(res.code == 1){
                            Toast.fail('Order cancelled')
                            this.$emit('refreshOrder')
                        }else{
                            Toast.fail(res.msg)
                        }
                    })
                })
                .catch(() => {
                });
            },
            // Review Now
            handleCollection(){
                let service = this.rows.service
                let order_service_arr = []
                for( let i in service ){
                    order_service_arr.push({order_service_id:service[i].order_service_id,service_id:service[i].service_id})
                }
                this.$router.push({path:'/orderCollection',query:{order_id:this.rows.order_id,data:JSON.stringify(order_service_arr)}})
            },
            // 待支付
            async handlePay(){
                const { getAbsoluteHashUrl, startStripeCheckout } = await import('@/utils/stripeCheckout')
                const res = await this.$api.orderPay({
                    order_id: this.rows.order_id,
                    success_url: getAbsoluteHashUrl('/order?pay=success'),
                    cancel_url: getAbsoluteHashUrl('/order?pay=cancel')
                })
                if(res.code == 1 && res.data){
                    try {
                        await startStripeCheckout({
                            checkoutUrl: res.data.checkout_url
                        })
                    } catch (e) {
                        Toast.fail(e.message || 'Failed to redirect to payment')
                    }
                }else{
                    Toast.fail(res.msg || 'Payment failed')
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .orderItem{
        width: 100%;
        font-size: .875rem;
        background: #fff;
        box-sizing: border-box;
        border-radius: .5rem;
        padding: 1rem;
        margin-bottom: 1rem;
        .orderMeta{
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: .75rem;
            color: #666666;
            margin-top: .5rem;
            .status{
                color: #1E3C3E;
            }
        }
        .dateGroup{
            width: 100%;
            height: auto;
            background: #F4F4F4;
            border-radius: .25rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding:0 1rem;
            box-sizing: border-box;
            margin: 1rem 0;
            .dateItem{
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 1rem;
                border-bottom: 1px solid #ccc;
                box-sizing: border-box;
            }
            .dateItem:last-child{
                margin-bottom: 0;
                border-bottom:0;
            }
            .dateTime{
                display: flex;
                align-items: center;
                color: #666666;
                .line{
                    margin: 0 0.2rem;
                    background: #666666;
                    width: .625rem;
                    height: .0625rem;
                }
            }
        }
        .priceBox{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .btnGroup{
                display: flex;
                align-items: center;
                gap:0.5rem;
                .Btn1, .Btn2{
                    padding: 0 0.75rem;
                    font-size: 0.8rem;
                }
            }
            .Btn1{
                width: auto;
                height: 2.125rem;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                background: #1E3C3E;
                border-radius: .25rem;
                padding: 0 1rem;
                box-sizing: border-box;
            }
            .Btn2{
                width: auto;
                height: 2.125rem;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #1E3C3E;
                background: #fff;
                border: 1px solid #1E3C3E;
                border-radius: .25rem;
                padding: 0 1rem;
                box-sizing: border-box;
            }
        }
    }
</style>
